import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'

import '../../src/util/install_sentry'

import './site_common'

import 'Components/refosumu/basics/breadcrumb/component'
import 'Components/refosumu/review_evaluation/component'
import 'Components/refosumu/reason_points/component'
import 'Components/refosumu/reform_timeline/component'
import 'Components/refosumu/reform_db_table/component'
import 'Components/refosumu/carousel_light/component'
import 'Components/refosumu/review_card/component'
import 'Components/refosumu/helpful_widget_for_review_detail/component'
import 'Components/refosumu/call_to_action_button/component'
import 'Components/refosumu/call_to_action_link/component'
import 'Components/refosumu/company_card/component'
import 'Components/refosumu/v2/floating/component'
import 'Components/refosumu/company_link_header/component'

import spToggleNav from '../../src/spToggleNav/spToggleNav'

$(() => {
  spToggleNav()
})
